<template>
  <div class="repurchase-table-wrapper">
    <slot></slot>
    <RkTable
      class="repurchase-table"
      :data="sliceEventList"
      :loading="loading"
      :finished="finished"
      :show-footer="showFooter"
    >
      <template #footer>
        <ShowMoreButton v-if="eventList.length > initLength" v-model="isMore" />
      </template>
      <RkTableColumn prop="tradeDate" label="回购日期" fixed align="left" :width="`${postcssPatch(120)}`">
        <template #default="{ row }">{{ $digitjs(row.tradeDate).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="averagePaidPerShare" label="回购均价" :width="`${postcssPatch(90)}`">
        <template #default="{ row }">{{ $digitjs(row.averagePaidPerShare).rounded() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="purchasedNumber" label="回购数量" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.purchasedNumber).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="totalAmountPaid" label="回购金额" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.totalAmountPaid).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="purchasedRateOfVolume" label="回购数量/总成交" :width="`${postcssPatch(120)}`">
        <template #header>
          <p>回购数量</p>
          <p>/总成交</p>
        </template>
        <template #default="{ row }">{{ $digitjs(row.purchasedRateOfVolume).unit('%').rounded(3) }}</template>
      </RkTableColumn>
      <RkTableColumn
        prop="purchasedSinceResolution"
        label="自普通决议案通过后股份回购数总量(股数)"
        :width="`${postcssPatch(180)}`"
      >
        <template #header>
          <p>自普通决议案通过后</p>
          <p>股份回购数总量(股数)</p>
        </template>
        <template #default="{ row }">{{ $digitjs(row.purchasedSinceResolution).convert(0) }}</template>
      </RkTableColumn>
      <RkTableColumn
        prop="purchasedRateSinceResolution"
        label="自普通决议案通过后股份回购数总量(%)"
        :width="`${postcssPatch(170)}`"
      >
        <template #header>
          <p>自普通决议案通过后</p>
          <p>股份回购数总量(%)</p>
        </template>
        <template #default="{ row }">{{ $digitjs(row.purchasedRateSinceResolution).unit('%').rounded() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  props: {
    showFooter: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number
    },
    initLength: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    sliceEventList() {
      if (this.total) {
        return this.eventList
      } else {
        return this.isMore ? this.eventList : this.eventList.slice(0, this.initLength)
      }
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-repurchase', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data?.slice(0, this.total) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.repurchase-table-wrapper {
  margin-bottom: var(--section-margin);
  background: var(--bg-color-2);
}

.repurchase-table {
  --table-tbody-font-size: 13px;
}
</style>
